import gql from 'graphql-tag';

import {graphqlAnonymous as graphql} from "../actions";

export default variables => graphql('auth', 'auth', gql`query Auth(
    $token: String!
) {
   auth(token: $token)
}`, variables)
